/*
 * Copyright (c) 2026, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

/**
 * API acronyms that must stay uppercase in user-facing labels.
 *
 * Add an acronym here when a new enum value contains one; otherwise sentence
 * casing would turn it into a word such as "Sdk" or "Vpn".
 */
const ACRONYMS = new Set(["ADB", "ID", "OS", "PIN", "SDK", "SSL", "VPN"])

/**
 * Converts an API enum constant into a sentence-case label.
 *
 * Underscores become spaces, the first word is capitalized, and the remaining
 * words are lowercase. Known acronyms keep their uppercase spelling.
 *
 * @param value - API enum value, or `undefined` when absent.
 * @returns The formatted label, or an empty string when `value` is empty.
 *
 * @example
 * formatEnum("ROOT_DETECTED") // "Root detected"
 * formatEnum("SDK_VERSION_CHANGED") // "SDK version changed"
 */
export function formatEnum(value: string | undefined): string {
    if (!value) return ""

    return value
        .split("_")
        .map((word, index) => {
            if (ACRONYMS.has(word)) return word

            const lower = word.toLowerCase()
            return index === 0 ? lower.charAt(0).toUpperCase() + lower.slice(1) : lower
        })
        .join(" ")
}
